import { createSelector } from 'reselect';
import mappings from './mappings';

export const combinedColumnsSelector = createSelector(
    state => state.commodityJobs.columns,
    columns => columns.map(column => ({
        ...column,
        ...mappings.find(col => col.id === column.id)
    }))
);

export const getDefaultFilters = state => (
    state.commodityJobs.defaultFilters
);

export const getLastUpdated = state => (
    state.commodityJobs.lastUpdated
);

export const getFilterDefinitions = state => (
    state.commodityJobs.filterDefinitions
);

export const getInitialised = state => (
    state.commodityJobs.initialised
);

export const getLoading = state => (
    state.commodityJobs.loading
);

export const getRows = state => (
    state.commodityJobs.rows
);

export const getLoadRequestMappings = state => (
    state.commodityJobs.loadRequestMappings
);

export const getCurrentServerFilters = state => (
    state.commodityJobs.currentServerFilters
);

export const getDateFrom = (state) => {
    if (state) {
        const filter = state.find(obj => obj.definition.id === 'runDate');
        if (filter && filter.value) {
            return filter.value.from;
        }
    }
    return null;
};

export const getDateTo = (state) => {
    if (state) {
        const filter = state.find(obj => obj.definition.id === 'runDate');
        if (filter && filter.value) {
            return filter.value.to;
        }
    }
    return null;
};

export const getDefaultSort = state => (
    state.commodityJobs.gridSorting
);
